/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 声かけフラグをセットする
 * @export
 * @interface DriverFeedbackFlagSetReq
 */
export interface DriverFeedbackFlagSetReq {
    /**
     * 営業所ID
     * @type {number}
     * @memberof DriverFeedbackFlagSetReq
     */
    officeId?: number;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof DriverFeedbackFlagSetReq
     */
    driverId?: number;
    /**
     * week
     * @type {number}
     * @memberof DriverFeedbackFlagSetReq
     */
    weekNo?: number;
    /**
     * year
     * @type {number}
     * @memberof DriverFeedbackFlagSetReq
     */
    year?: number;
    /**
     * 声かけフラグon/off
     * @type {boolean}
     * @memberof DriverFeedbackFlagSetReq
     */
    feedbackGiven?: boolean;
}

export function DriverFeedbackFlagSetReqFromJSON(json: any): DriverFeedbackFlagSetReq {
    return DriverFeedbackFlagSetReqFromJSONTyped(json, false);
}

export function DriverFeedbackFlagSetReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverFeedbackFlagSetReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'weekNo': !exists(json, 'week_no') ? undefined : json['week_no'],
        'year': !exists(json, 'year') ? undefined : json['year'],
        'feedbackGiven': !exists(json, 'feedback_given') ? undefined : json['feedback_given'],
    };
}

export function DriverFeedbackFlagSetReqToJSON(value?: DriverFeedbackFlagSetReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'driver_id': value.driverId,
        'week_no': value.weekNo,
        'year': value.year,
        'feedback_given': value.feedbackGiven,
    };
}


